import { TESTIMONIALS, CLIENTS } from "@/lib/data";
import { Reveal, SectionLabel } from "@/components/Reveal";

export const Testimonials = () => (
  <section className="relative mx-auto max-w-[1400px] px-6 sm:px-10 py-24 lg:py-36">
    <Reveal>
      <SectionLabel>Client love</SectionLabel>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.02] max-w-3xl mb-14">
        Trusted by founders who <span className="text-gradient">demand more.</span>
      </h2>
    </Reveal>

    <div className="grid md:grid-cols-2 gap-5 mb-16">
      {TESTIMONIALS.map((t, i) => (
        <Reveal key={t.name} delay={i * 0.08}>
          <div className="group relative h-full rounded-3xl border border-[var(--border-subtle)] bg-[var(--surface-card)] p-8 sm:p-10 hover-card-glow">
            <div className="mb-6 flex gap-1 text-[var(--accent-primary)]">
              {"★★★★★".split("").map((s, j) => <span key={j}>{s}</span>)}
            </div>
            <p className="font-display text-xl sm:text-2xl font-semibold leading-snug text-[var(--text-primary)] mb-8">
              "{t.quote}"
            </p>
            <div className="flex items-center gap-3 border-t border-[var(--border-subtle)] pt-6">
              <span className="grid h-11 w-11 place-items-center rounded-full btn-accent font-display font-bold text-sm">
                {t.name.split(" ").map((n) => n[0]).join("")}
              </span>
              <div>
                <div className="font-heading font-semibold">{t.name}</div>
                <div className="font-body text-sm text-[var(--text-muted)]">{t.role}</div>
              </div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>

    <div className="relative overflow-hidden marquee-pause border-y border-[var(--border-subtle)] py-8">
      <div className="flex w-max marquee-slow">
        {[...CLIENTS, ...CLIENTS].map((c, i) => (
          <span key={i} className="px-10 font-display text-3xl sm:text-4xl font-bold text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors whitespace-nowrap">
            {c}
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[var(--bg-primary)] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[var(--bg-primary)] to-transparent" />
    </div>
  </section>
);
